import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { loadMathPicker } from "../picker/math-module";

import { bindWxCanvasModules } from "../canvas/contributions/wx/modules";

import { bindWxWindowContribution } from "../window/contributions/wx-contribution";

import { WxEnvContribution } from "./contributions/wx-contribution";

export function bindWxEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, WxEnvContribution)) || (container.bind(WxEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(WxEnvContribution));
}

export function loadWxEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadWxEnv.__loaded || (loadWxEnv.__loaded = !0, bindWxEnv(container), bindWxCanvasModules(container), 
    bindWxWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadWxEnv.__loaded = !1;

export function initWxEnv() {
    loadWxEnv();
}
//# sourceMappingURL=wx.js.map